var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"min-height":"500px","min-width":"1100px","elevation":"0"}},[_c('UnityTemplatePackConfig')],1)}
var staticRenderFns = []

export { render, staticRenderFns }